
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {formatDate, formatDateTime} from "@/auxillary/date-format";
import {translate} from "@/auxillary/translation";
import {MdbsCore} from "@/api/tsclient";
import DataFieldsReadonly from "@/components/study/DataFieldsReadonly.vue";
import {safetyModule} from "@/store";
import ReadonlyDataFields from "@/models/ReadonlyDataFields";
import IEventReportItemDto = MdbsCore.IEventReportItemDto;


@Component({
  components: {DataFieldsReadonly},
  filters: {
    formatDate,
    formatDateTime,
    translate
  }
})
export default class EventReportContent extends Vue {

  @Prop({required: false, default: () => null})
  eventReport: IEventReportItemDto;

  roDataFields: ReadonlyDataFields = ReadonlyDataFields.empty();

  closeDialog() {
    this.$emit("ok");
  }

  @Watch("eventReport", {immediate: true, deep: false})
  async handleEventReportChanged(newReport: IEventReportItemDto) {
    await safetyModule.loadEventReportFields({reportId: newReport.reportId!});
    const eventReportFields = safetyModule.EventReportFields;

    this.roDataFields = ReadonlyDataFields.fromEventReportFields(eventReportFields);
  }
}
